export default [
  {
    path: 'running-rank',
    name: 'tzy_university_running_rank',
    component: () => import('../views/running-rank/RunningRank.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '今日排行榜',
    },
  },
]
